<template>
    <form class="box_multiple" :style="getImage" method="post" action="" enctype="multipart/form-data">
        <div id="drop-zone-multiple" :class="{ dragging: isDragging }"
            @dragover="dragover" @drop="drop" @dragleave="dragleave" @dragend="dragend">
            <div v-if="!isLoading && isDragging" class="drop-zone-caption" style="padding-top: 10px;">Drop here to Create NEW</div>
            <span v-if="!isLoading" class="btn btn-primary btn-file" style="position: relative">
                <button v-if="!isDragging" class="mdl-button"><i class="material-icons">collections</i> UPLOAD MULTIPLE IMAGES</button> 
                <input v-if="!isDragging" @change="selectLocal" type="file" id="drop-zone-file" name="files[]" multiple>
            </span>
            <div v-if="isLoading" style="font-size: 14px; color: white;">
                <div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active is-upgraded" data-upgraded=",MaterialSpinner"><div class="mdl-spinner__layer mdl-spinner__layer-1"><div class="mdl-spinner__circle-clipper mdl-spinner__left"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__gap-patch"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__circle-clipper mdl-spinner__right"><div class="mdl-spinner__circle"></div></div></div><div class="mdl-spinner__layer mdl-spinner__layer-2"><div class="mdl-spinner__circle-clipper mdl-spinner__left"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__gap-patch"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__circle-clipper mdl-spinner__right"><div class="mdl-spinner__circle"></div></div></div><div class="mdl-spinner__layer mdl-spinner__layer-3"><div class="mdl-spinner__circle-clipper mdl-spinner__left"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__gap-patch"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__circle-clipper mdl-spinner__right"><div class="mdl-spinner__circle"></div></div></div><div class="mdl-spinner__layer mdl-spinner__layer-4"><div class="mdl-spinner__circle-clipper mdl-spinner__left"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__gap-patch"><div class="mdl-spinner__circle"></div></div><div class="mdl-spinner__circle-clipper mdl-spinner__right"><div class="mdl-spinner__circle"></div></div></div></div>
                <div style="margin-top: 5px;">LOADING...</div>
            </div>
        </div>
    </form>
</template>
<script>

import UploadTools from './UploadTools.js'

var dropzoneMultipleComponent;

export default{
    name: "DropzoneFirebaseMultiple",
    data: () => ({
        isDragging: false,
        isLoading: false,
        uploadHash: {}
        // bgImage: "fakecover.jpg"
    }),
    props: ['folder', 'elRef'],
    computed: {
        getImage(){
            if(this.bgImage) return 'background-image: url(' + this.bgImage + ');';
            return 'background-image: none;';
        }
    },
    watch:{
        bgImage(val){
            dropzoneMultipleComponent.isLoading = false;
        } 
    },
    created(){
        dropzoneMultipleComponent = this;
        window.addEventListener("dragenter", function(e)
        {
            dropzoneMultipleComponent.isDragging = true;
        });
        window.addEventListener("dragleave", function(e)
        {
            dropzoneMultipleComponent.isDragging = false;
        });
        window.addEventListener("dragend", function(e)
        {
            dropzoneMultipleComponent.isDragging = false;
        });
    },
    methods: {
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        selectLocal(e){
            e.preventDefault();
            var files = e.target.files;

            //We need to send dropped files to Server
            this.createAndUpload(files);
        },
        drop(e) {
            e.preventDefault();
            this.isDragging = false;
            var files = e.dataTransfer.files;
            //We need to send dropped files to Server
            this.createAndUpload(files);
        },
        createAndUpload(files){
            for(var fileId in files){
                var file = files[fileId];
                var fileNameArray = file.name.split(".");
                fileNameArray.pop();
                var fileName = fileNameArray.join(" "); 
                var element = this.elRef.push({'name': fileName});
                var bgImageName = element.key;
                UploadTools.handleSingleNamedFileUpload(file, this.folder, element.key, this.elRef.child(element.key).child('bg'));
            }
        },
        dragleave(e) {
            e.preventDefault();
            // this.isDragging = false;
        },
        dragend(e) {
            e.preventDefault();
            // this.isDragging = false;
        }
    }
}



</script>
<style>
    .box_multiple, #drop-zone-multiple{
        margin: 0;
        padding: 0 0 0 0 ;
        width: 100%;
        height: 100%;
    }
    #drop-zone-multiple{
        padding-top: 12.5px;
    }
    .box_multiple #dragandrophandler.dragging {
        border: 2px dotted #ffffff;
        color: #ffffff;
        background-color: rgba(90, 90, 90, 0.3);
    }

    .box_multiple #drop-zone-multiple.dragging {
        padding: 5px;
        outline: 2px dashed #ffffff;
        -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
        transition: outline-offset .15s ease-in-out, background-color .15s linear;
        background-color: rgba(90, 90, 90, 0.3);
        /* position: relative; */
        /* padding: 100px 20px; */
    }

    .box_multiple #drop-zone-multiple .mdl-button{
        opacity: 0.66;
        font-weight: bold;
    }
    
    .box_multiple #drop-zone-multiple:hover, #drop-zone-multiple.dragging{
      background-color: rgba(90, 90, 90, 0.6);
    } 

    .box_multiple .btn-file input[type=file] {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        cursor: pointer;
    }

    .box_multiple input[type=file] {
        display: block;
    }

    .box_multiple #drop-zone-multiple .drop-zone-caption {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
        opacity: 0.66;
        padding: 5px;
        margin: 5px;
    }
</style>


// WEBPACK FOOTER //
// DropzoneFirebaseMultiple.vue?a34df11a